import { ApiCurrency } from "@incendium/api";
import { StandardTextFieldProps } from "@mui/material";
import ValidatorAutocomplete from "features/forms/ValidatorAutocomplete";
import { enumToArray } from "Helpers/enumToText";
import { CallbackOrVal } from "Interfaces";
import { useMemo } from "react";
import currencyData from "../currencys.json";

interface ICurrencyPickerProps extends StandardTextFieldProps {
  currency: ApiCurrency | undefined;
  setCurrency: (v: CallbackOrVal<ApiCurrency>) => void;
}

function CurrencyPicker({
  currency,
  setCurrency,
  size,
  label,
  helperText,
}: ICurrencyPickerProps) {
  const options = useMemo(() => {
    return enumToArray(ApiCurrency).filter((c) => !!currencyData[c]);
  }, []);

  const selectedValue = useMemo(() => {
    return currency
      ? currencyData[currency]
        ? `${currencyData[currency].symbol} (${currencyData[currency].name})`
        : currency
      : "";
  }, [currency]);

  return (
    <ValidatorAutocomplete
      size={size}
      label={label}
      helperText={helperText}
      name="currency"
      validators={["required"]}
      errorMessages={["Currency is required"]}
      onChange={(e) => setCurrency(e.target.value as ApiCurrency)}
      value={selectedValue as ApiCurrency}
      options={options}
      getOptionLabel={(o) =>
        currencyData[o]
          ? `${currencyData[o].symbol} (${currencyData[o].name})`
          : o
      }
    />
  );
}

export default CurrencyPicker;
